
export const user = state => state.user

export const college = state => state.college



// WEBPACK FOOTER //
// ./src/store/getters.js